<template>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>新增资料标签</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            
            <v-text-field
              v-model="formData.name"
              label="标签名称"
              :rules="[v => !!v || '请输入标签名称']"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">取消</v-btn>
          <v-btn color="blue darken-1" text @click="submit">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
import { materialApi } from '@/api/material'
  
  export default {
    name: 'CreateMaterialTagPopup',
    data() {
      return {
        dialog: false,
        valid: false,
        formData: {
          name: '',
        },
      }
    },
    methods: {
      open() {
        this.dialog = true
      },
      close() {
        this.dialog = false
        this.$refs.form.reset()
      },
      async submit() {
        if (!this.$refs.form.validate()) return
        
        try {
          await materialApi.createTag({
                "name": this.formData.name,
            });
          this.$emit('tag-created');
          this.close();
          console.log('标签创建成功');
        //   this.$toast.success('创建成功')
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
          this.$toast.error('创建失败：' + errorMessage);
        }
      }
    }
  }
  </script> 